import { faFacebook } from "@fortawesome/free-brands-svg-icons/faFacebook";
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons/faLinkedin";
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, CardContent, Grid, TextField } from "@mui/material";
import CardHeaderColor from "components/MuiExtras/Card/CardHeaderColor";
import MuiContainer from "components/MuiExtras/MuiContainer";
import { UserSocialNetworkType } from "models/ApiEnums";
import { UserSocialNetworkModel } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    networks: UserSocialNetworkModel[];
    onChange: (v: UserSocialNetworkModel[]) => void;
}

type Props = IProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class UserEditSocialNetworks extends React.Component<Props> {


    private updatePhone = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { networks } = this.props;

        const name = e.currentTarget.name;

        var network = networks.find(p => p.networkName == name);
        if (network == null) {
            networks.push({ networkName: name, value: e.currentTarget.value });
        }
        else {
            network.value = e.currentTarget.value;
        }

        this.props.onChange(networks);
    };

    private renderNetwork(networkName: string) {
        var network = this.props.networks.find(p => p.networkName == networkName);

        var icon = networkName == UserSocialNetworkType[UserSocialNetworkType.Facebook]
            ? faFacebook
            : networkName == UserSocialNetworkType[UserSocialNetworkType.Instagram]
                ? faInstagram
                : networkName == UserSocialNetworkType[UserSocialNetworkType.Linkedin]
                    ? faLinkedin
                    : faTwitter;


        return (
            <TextField
                margin="normal"
                fullWidth={true}
                value={network ? network.value : ""}
                onChange={this.updatePhone}
                placeholder={networkName}
                InputProps={{
                    name: networkName,
                    startAdornment: <><FontAwesomeIcon color="#909090" icon={icon} fixedWidth />&nbsp;</>
                }}
            />
        );
    }

    render() {

        return (
            <Card>
                <CardHeaderColor color="primary" title={this.props.t("Views.User.Components.UserEditSocialNetworks.HeaderTitle")} />

                <CardContent>
                    <MuiContainer margin="dense">
                        <Grid container alignItems={"baseline"}>
                            <Grid item xs={12}>{this.renderNetwork(UserSocialNetworkType[UserSocialNetworkType.Facebook])}</Grid>
                            <Grid item xs={12}>{this.renderNetwork(UserSocialNetworkType[UserSocialNetworkType.Instagram])}</Grid>
                            <Grid item xs={12}>{this.renderNetwork(UserSocialNetworkType[UserSocialNetworkType.Linkedin])}</Grid>
                            <Grid item xs={12}>{this.renderNetwork(UserSocialNetworkType[UserSocialNetworkType.Twitter])}</Grid>
                        </Grid>
                    </MuiContainer>

                </CardContent>

            </Card>
        );
    }
}

export default withTranslation()(UserEditSocialNetworks);